<template>
  <div class="mx-auto w-[210mm] print:mx-0 print:w-full">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
<style>
  @media print {
    @page {
      size: A4 portrait;
      margin-top: 60px;
      margin-bottom: 60px;
      margin-left: 40px;
      margin-right: 40px;
    }
  }
</style>
